// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useIntlApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getIntl = () => request("GET", `${API_STAGES_URL}/v1/intl/matrix`)

  const updateIntl = data =>
    request("POST", `${API_STAGES_URL}/v1/intl/update`, data)

  return [
    requestState,
    payload,
    error,
    {
      getIntl,
      updateIntl,
    },
  ]
}

export default useIntlApi
